/** Usage & Upgrade-Trigger (product/05, business/03) */
import { z } from "zod";
import { PLAN_LIMITS } from "./plans.js";
/**
 * Katalog der Paywall/Upgrade-Trigger — Single Source of Truth.
 * Typ UND Zod-Schema unten werden hieraus abgeleitet; eine zweite handgepflegte
 * Liste würde beim nächsten Trigger still auseinanderlaufen und über das
 * Response-Gate in GET /usage als 500 für echte Nutzer landen (WR-09).
 */
export const UPGRADE_TRIGGERS = ["daily_limit", "monthly_limit", "premium_preview"];
/** Copy-Keys für Upgrade-Prompts (product/05) */
export const UPGRADE_COPY = {
    unlock_captures: "Unlock unlimited captures",
    unlock_intelligence: "Unlock company graph and intent signals",
    unlock_team: "Unlock team sharing",
};
export function getLimitsForPlan(planId) {
    const limits = PLAN_LIMITS[planId];
    return {
        capturesPerDay: limits.capturesPerDay,
        capturesPerMonth: limits.capturesPerMonth,
    };
}
/**
 * Plan-Id-Enum direkt aus PLAN_LIMITS abgeleitet — contracts bleibt Single Source of Truth.
 * Eine zweite handgepflegte Plan-Liste würde bei einem neuen Tarif still auseinanderlaufen.
 */
export const PlanIdSchema = z.enum(Object.keys(PLAN_LIMITS));
/**
 * Upgrade-Trigger-Enum direkt aus UPGRADE_TRIGGERS abgeleitet — kein handgepflegter
 * Zweitspiegel der Union (gleiches Anti-Drift-Muster wie PlanIdSchema).
 */
export const UpgradeTriggerSchema = z.enum(UPGRADE_TRIGGERS).nullable();
/** Zählerfeld: nicht-negative Ganzzahl (Counts können nie negativ oder fraktional sein). */
const CountSchema = z.number().int().nonnegative();
/** Limit-Feld: nicht-negative Ganzzahl oder null (null = unlimited / fair use). */
const LimitSchema = z.number().int().nonnegative().nullable();
/** Nutzungs-Payload von GET /usage — Basis für UI-Gating im Dashboard. */
export const UsageSchema = z.object({
    planId: PlanIdSchema,
    capturesToday: CountSchema,
    capturesThisMonth: CountSchema,
    capturesPerDayLimit: LimitSchema,
    capturesPerMonthLimit: LimitSchema,
    canCapture: z.boolean(),
    upgradeTrigger: UpgradeTriggerSchema,
    upgradeCopy: z.string().nullable(),
});
/** Vollständige GET /usage Erfolgsantwort — Response-seitiges Gegenstück zu SG6 (API-01). */
export const UsageResponseSchema = z.object({
    ok: z.literal(true),
    usage: UsageSchema,
});
//# sourceMappingURL=usage.js.map